import './Page.css';
import SettingsComponent from "../componetns/menu/settings/SettingsComponent";

function Settings() {
    return (
        <div className="main_work_field">
            <SettingsComponent/>
        </div>
    );
}

export default Settings;